import { environment } from "../../../environments/environment";
import { ChartSelectionCard } from "../Interfaces/chart-selection-card";
import { AppConstants } from "./app-constants";

export class AreaChartConstants {
  areaChartImgFolderPath: string = "../../../assets/Images/AreaChart/";
  /*baseUrl: string = environment.baseUrl;*/
  areaModuleRoutePath = AppConstants.areaCategoryPathMap.chartModuleRoutePath + "/";
  chartDescriptions: any = this.getChartDescriptions();
  areaChartModuleComponentPath: string = AppConstants.areaCategoryPathMap.moduleFolderPath;


  areaChartTypes: ChartSelectionCard[] = [
    {
      "imgUrl": "",
      routePath: this.areaModuleRoutePath + "AreaChart1Custom",
      routePath2: "",
      description: [],
      chartFolderPath: this.areaChartModuleComponentPath + "area-chart1",
      chartFolderPath2: "",
      imgClassName: "areaChart01",
      chartTitle: "AREA CHART",
      chartId: 1,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Area chart"
    },
    // {
    //   "imgUrl": this.areaChartImgFolderPath + "02areachart.png",
    //   routePath: this.areaModuleRoutePath + "AreaChart2",
    //   routePath2: "",
    //   description: [],
    //   chartFolderPath: this.areaChartModuleComponentPath + "area-chart2",
    //   chartFolderPath2: "",
    //   imgClassName:"",
    //   chartTitle:"",
    //   chartId:2
    // },
    // {
    //   "imgUrl": this.areaChartImgFolderPath + "03areachart.png",
    //   routePath: this.areaModuleRoutePath + "AreaChart3",
    //   routePath2: "",
    //   description: [],
    //   chartFolderPath: this.areaChartModuleComponentPath + "area-chart3",
    //   chartFolderPath2: "",
    //   imgClassName:"",
    //   chartTitle:"",
    //   chartId:3
    // },
    // {
    //   "imgUrl": this.areaChartImgFolderPath + "04areachart.png",
    //   routePath: this.areaModuleRoutePath + "AreaChart4",
    //   routePath2: "",
    //   description: [],
    //   chartFolderPath: this.areaChartModuleComponentPath + "area-chart4",
    //   chartFolderPath2: "",
    //   imgClassName:"",
    //   chartTitle:"",
    //   chartId:4
    // },
  ]

  getChartDescriptions() {
    let genericDescription = [
      "Area colour: solid single color, solid multicolour, linear gradient colour (two variation colour)",
      "X-Axis: Text, image and both (text/image) can be added.",
      "X-axis text can be single colour or solid multicolour.",
      "Y-axis label line can be dotted or solid line.",
      "Legend symbol can be square or circle or can be disabled.",
      "Markers in plot options can be of different shape like triangle, square, circle."
    ];
    let chartDescription = {
      chart1Description: [
        "Area colour: solid single color, solid multicolour, linear gradient colour (two variation colour)",
        "X-Axis: Text, image and both (text/image) can be added.",
        "X-axis text can be single colour or solid multicolour.",
        "Y-axis label line can be dotted or solid line.",
        "Markers in plot options can be of different shape like triangle, square, circle."
      ],
      genericAreaChartDescription: genericDescription,
    }
    return chartDescription;
  }

}

